  import React, { useState, useEffect } from 'react';
  import {
    Box,
    Typography,
    IconButton,
  } from '@mui/material';
  import { toast } from 'react-toastify';
  import { GetAllStates } from '../../screen/auth/action/util_actions';
  import { GetAllCityOfState } from '../../v2/Onboarding/auth/action';
  import StandardChip from '../../v2/MUI_custom_component/chips/StandardChip';
  import { toCapitalized } from '../../v2/Utils/Capitalize';
  import IconReusable from '../../components/IconReusable';
import CustomChip from './CustomChip';

  const BillingInfo = ({
    buyer = {},
    selectedRole = '',
    title = 'Ship to Party',
    showRoleChip = true,
    showDeleteButton = false,
    onDelete = null,
    orderSummary = false,
    sx = {},
    
  }) => {
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);

    const getStates = async () => {
      const { data, error, message } = await GetAllStates();

      if (!error) {
        setStates(
          data.map((state) => ({
            label: state.state_name,
            value: state.id,
          })),
        );
      } else {
        return toast.error(message);
      }
    };

    const getDistricts = async (stateId) => {
      setDistricts([]);

      const { data, error, message } = await GetAllCityOfState(stateId);

      if (!error) {
        setDistricts(
          data.map((district) => ({
            label: district.district_name,
            value: district.id,
          })),
        );
      } else return toast.error(message);
    };

    useEffect(() => {
      if (buyer.state_id) getDistricts(buyer.state_id);
    }, [buyer.state_id]);
    useEffect(() => {
      getStates();
    }, []);

    const getStateName = (stateId) => {
      const state = states.find(s => s.value === stateId);
      return state ? state.label : stateId;
    };

    const getDistrictName = (districtId) => {
      const district = districts.find(d => d.value === districtId);
      return district ? district.label : districtId;
    };

    const safeCapitalize = (text) => {
      return text && typeof text === 'string' ? toCapitalized(text) : text;
    };
    return (
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="labelD">
            {title}
          </Typography>
          {showDeleteButton && onDelete && (
            <IconButton size="small" color="error" onClick={onDelete}>
              <IconReusable name='Delete' color='#995A00' size={'20px'} /> 
            </IconButton>
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between'}}>
              {buyer?.company_name && (
                <Typography variant="bodyL">
                  {buyer.company_name}
                </Typography> 
              )}
              {showRoleChip && (
                  <Box>
                    {(selectedRole || buyer.selectedRole) && (
                      <CustomChip 
                        label={selectedRole || buyer.selectedRole} 
                        selected={false}
                        variant="outlined"
                      />
                    )}
                  </Box>
              )}
            </Box>
            {buyer?.company_phone_no && (
              <Box sx={{ display: 'flex', gap: 1}}>
                <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                  Phone
                </Typography> 
                <Typography variant="p3">
                  {buyer.company_phone_no}
                </Typography> 
              </Box>
            )}
            {(buyer?.company_address1 || buyer.company_address2 || buyer.company_address3) && !(buyer.company_registered_address) && (
              <Box sx={{ display: 'flex', gap: 1}}>
                <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666'  }}>
                  Registered Address
                </Typography> 
                <Typography variant="p3" sx={{ maxWidth: { md: '400px'} }}>
                  {[
                    safeCapitalize(buyer?.company_address1),
                    safeCapitalize(buyer?.company_address2),
                    safeCapitalize(buyer?.company_address3),
                    buyer?.district_id && safeCapitalize(getDistrictName(buyer.district_id)),
                    buyer?.state_id && safeCapitalize(getStateName(buyer.state_id)),
                    buyer?.company_pincode
                  ].filter(Boolean).join(', ')}
                </Typography> 
              </Box>
            )}
            {buyer?.company_registered_address && (
              <Box sx={{ display: 'flex', gap: 1}}>
                <Typography variant="labelM" sx={{ minWidth: '150px',  color: '#666'  }}>
                  Registered Address
                </Typography> 
                <Typography variant="p3" sx={{ maxWidth: { md: '400px'} }}>
                  {buyer.company_registered_address}
                </Typography> 
              </Box>
            )}
            {(buyer?.erp_code || buyer?.selected_esi_info?.external_system_code) && (
              <Box sx={{ display: 'flex', gap: 1}}>
                <Typography variant="labelM" sx={{ minWidth: '150px',  color: '#666'  }}>
                  ERP Code
                </Typography> 
                <Typography variant="p3">
                  {buyer.erp_code || buyer?.selected_esi_info?.external_system_code}
                </Typography> 
              </Box>
            )}
          </Box>
        </Box>
      </>
    );
  };

  export default BillingInfo;